import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { connectState } from "../libs/connect"



import DaosPage from './DaosPage.vue';
import LearningsPage from './LearningsPage.vue';
import AuctionsPage from './AuctionsPage.vue';
import GrantsPage from './GrantsPage.vue';
import VotesPage from './VotesPage.vue';
import TreassuresPage from './TreassuresPage.vue';
import ChatsPage from './ChatsPage.vue';

const __default__ = {
  name: 'HomePage',
  props: {
    msg: String
  }
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const activeIndex = connectState.activeIndex;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(activeIndex)==='1')
      ? (_openBlock(), _createBlock(DaosPage, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(activeIndex)==='2')
      ? (_openBlock(), _createBlock(LearningsPage, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(activeIndex)==='3')
      ? (_openBlock(), _createBlock(AuctionsPage, { key: 2 }))
      : _createCommentVNode("", true),
    (_unref(activeIndex)==='4')
      ? (_openBlock(), _createBlock(GrantsPage, { key: 3 }))
      : _createCommentVNode("", true),
    (_unref(activeIndex)==='5')
      ? (_openBlock(), _createBlock(VotesPage, { key: 4 }))
      : _createCommentVNode("", true),
    (_unref(activeIndex)==='6')
      ? (_openBlock(), _createBlock(TreassuresPage, { key: 5 }))
      : _createCommentVNode("", true),
    (_unref(activeIndex)==='7')
      ? (_openBlock(), _createBlock(ChatsPage, { key: 6 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})